import { DrugNurseryDomainService } from './domain';
import { DrugFactory } from './entity/drugFactory';

import type { Logger } from '@/infra/logger';
import type { WagakoNurseryIApi } from '@/infra/wagakoNurseryIApi';
import type { DrugJson } from '@/types/domain/drug/entities/drugEntity';

/**
 * 薬アプリケーションサービス(施設)
 */
export class DrugNurseryApplicationService {
  private service!: DrugNurseryDomainService;

  private drugFactory = new DrugFactory();

  /**
   * Injection
   * @param wagakoNurseryApi wagakoNurseryApi
   * @param logger logger
   */
  public inject(
    wagakoNurseryApi: WagakoNurseryIApi,
    logger: Logger,
  ) {
    this.service = new DrugNurseryDomainService(logger);
    this.service.inject(wagakoNurseryApi);
  }

  /**
   * sendNurseryDrug
   * @param input input
   */
  async sendNurseryDrug(
    input: DrugJson,
  ) {
    const entity = this.drugFactory.createFromJson(input);
    await this.service.sendNurseryDrug(entity);
  }

  /**
   * removeNurseryDrug
   * @param input input
   */
  async removeNurseryDrug(
    input: DrugJson,
  ) {
    const entity = this.drugFactory.createFromJson(input);
    await this.service.removeNurseryDrug(entity);
  }
}
